// // // src/pages/user/Services.jsx
// // import React, { useState, useEffect } from 'react';
// // import ServiceCard from '../../components/user/ServiceCard';
// // import { getServices } from '../../utils/api';

// // const Services = () => {
// //     const [services, setServices] = useState([]);
// //     const [filteredServices, setFilteredServices] = useState([]);
// //     const [activeCategory, setActiveCategory] = useState('all');

// //     const categories = [
// //         'all',
// //         'MINING',
// //         'MECHANICAL', 
// //         'ELECTRICAL',
// //         'CIVIL SERVICES',
// //         'PRODUCTS SUPPLIES'
// //     ];

// //     useEffect(() => {
// //         loadServices();
// //     }, []);

// //     useEffect(() => {
// //         if (activeCategory === 'all') {
// //             setFilteredServices(services);
// //         } else {
// //             setFilteredServices(services.filter(service => 
// //                 service.category === activeCategory
// //             ));
// //         }
// //     }, [activeCategory, services]);

// //     const loadServices = async () => {
// //         try {
// //             const data = await getServices();
// //             setServices(data);
// //         } catch (error) {
// //             console.error('Error loading services:', error);
// //         }
// //     };

// //     return (
// //         <div className="min-h-screen bg-gray-50 py-8">
// //             <div className="container mx-auto px-4">
// //                 <h1 className="text-4xl font-bold text-center mb-8">Our Services</h1>
                
// //                 {/* Category Filter */}
// //                 <div className="flex flex-wrap justify-center gap-2 mb-8">
// //                     {categories.map(category => (
// //                         <button
// //                             key={category}
// //                             onClick={() => setActiveCategory(category)}
// //                             className={`px-4 py-2 rounded-full capitalize ${
// //                                 activeCategory === category 
// //                                     ? 'bg-blue-600 text-white' 
// //                                     : 'bg-white text-gray-700 border hover:bg-gray-100'
// //                             }`}
// //                         >
// //                             {category.toLowerCase().replace('_', ' ')}
// //                         </button>
// //                     ))}
// //                 </div>

// //                 {/* Services Grid */}
// //                 <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
// //                     {filteredServices.map(service => (
// //                         <ServiceCard key={service.id} service={service} />
// //                     ))}
// //                 </div>

// //                 {filteredServices.length === 0 && (
// //                     <div className="text-center py-12">
// //                         <p className="text-gray-500 text-lg">No services found in this category.</p>
// //                     </div>
// //                 )}
// //             </div>
// //         </div>
// //     );
// // };

// // export default Services;



// import React, { useState, useEffect } from 'react';
// import ServiceCard from '../../components/user/ServiceCard';
// import { getServices } from '../../utils/api';

// const Services = () => {
//     const [services, setServices] = useState([]);
//     const [filteredServices, setFilteredServices] = useState([]);
//     const [activeCategory, setActiveCategory] = useState('all');
//     const [loading, setLoading] = useState(true);

//     const categories = [
//         'all',
//         'MINING',
//         'MECHANICAL', 
//         'ELECTRICAL',
//         'CIVIL SERVICES',
//         'PRODUCTS SUPPLIES'
//     ];

//     useEffect(() => {
//         loadServices();
//     }, []);

//     useEffect(() => {
//         if (activeCategory === 'all') {
//             setFilteredServices(services);
//         } else {
//             setFilteredServices(services.filter(service => 
//                 service.category === activeCategory
//             ));
//         }
//     }, [activeCategory, services]);

//     const loadServices = async () => {
//         try {
//             setLoading(true);
//             const data = await getServices();
            
//             // Handle different response structures
//             let servicesArray = [];
            
//             if (Array.isArray(data)) {
//                 servicesArray = data;
//             } else if (data && data.data && Array.isArray(data.data)) {
//                 servicesArray = data.data;
//             } else if (data && Array.isArray(data.services)) {
//                 servicesArray = data.services;
//             } else {
//                 console.error('Unexpected data structure:', data);
//                 servicesArray = [];
//             }
            
//             // Filter only active services for user display
//             const activeServices = servicesArray.filter(service => 
//                 service.is_active !== false
//             );
            
//             setServices(activeServices);
//             setFilteredServices(activeServices);
//         } catch (error) {
//             console.error('Error loading services:', error);
//             setServices([]);
//             setFilteredServices([]);
//         } finally {
//             setLoading(false);
//         }
//     };

//     if (loading) {
//         return (
//             <div className="min-h-screen flex items-center justify-center">
//                 <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
//             </div>
//         );
//     }

//     return (
//         <div className="min-h-screen bg-gray-50 py-8">
//             <div className="container mx-auto px-4">
//                 <h1 className="text-4xl font-bold text-center mb-8">Our Services</h1>
                
//                 {/* Category Filter */}
//                 <div className="flex flex-wrap justify-center gap-2 mb-8">
//                     {categories.map(category => (
//                         <button
//                             key={category}
//                             onClick={() => setActiveCategory(category)}
//                             className={`px-4 py-2 rounded-full capitalize ${
//                                 activeCategory === category 
//                                     ? 'bg-blue-600 text-white' 
//                                     : 'bg-white text-gray-700 border hover:bg-gray-100'
//                             }`}
//                         >
//                             {category.toLowerCase().replace('_', ' ')}
//                         </button>
//                     ))}
//                 </div>

//                 {/* Services Grid */}
//                 <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
//                     {filteredServices.map(service => (
//                         <ServiceCard key={service.id} service={service} />
//                     ))}
//                 </div>

//                 {filteredServices.length === 0 && !loading && (
//                     <div className="text-center py-12">
//                         <p className="text-gray-500 text-lg">No services found in this category.</p>
//                     </div>
//                 )}
//             </div>
//         </div>
//     );
// };

// export default Services;


// src/pages/user/Services.jsx
import React, { useState, useEffect, useMemo } from 'react';
import ServiceCard from '../../components/user/ServiceCard';
import { getServices } from '../../utils/api';

const Services = () => {
    const [services, setServices] = useState([]);
    const [filteredServices, setFilteredServices] = useState([]);
    const [activeCategory, setActiveCategory] = useState('all');
    const [loading, setLoading] = useState(true);

    // Extract unique categories from services data
    const categories = useMemo(() => {
        // Start with 'all' category
        const cats = ['all'];
        
        // Extract unique categories from services
        if (services && services.length > 0) {
            services.forEach(service => {
                if (service.category && !cats.includes(service.category)) {
                    cats.push(service.category);
                }
            });
        }
        
        return cats;
    }, [services]);

    useEffect(() => {
        loadServices();
    }, []);

    useEffect(() => {
        if (activeCategory === 'all') {
            setFilteredServices(services);
        } else {
            setFilteredServices(
                services.filter(service => 
                    service.category === activeCategory
                )
            );
        }
    }, [activeCategory, services]);

    const loadServices = async () => {
        try {
            setLoading(true);
            const data = await getServices();
            
            // Handle different response structures
            let servicesArray = [];
            
            if (Array.isArray(data)) {
                servicesArray = data;
            } else if (data && data.data && Array.isArray(data.data)) {
                servicesArray = data.data;
            } else if (data && Array.isArray(data.services)) {
                servicesArray = data.services;
            } else {
                console.error('Unexpected data structure:', data);
                servicesArray = [];
            }
            
            // Filter only active services for user display
            const activeServices = servicesArray.filter(service => 
                service.is_active !== false
            );
            
            setServices(activeServices);
            setFilteredServices(activeServices);
        } catch (error) {
            console.error('Error loading services:', error);
            setServices([]);
            setFilteredServices([]);
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-gray-50">
            {/* Hero Section */}
            <section className="bg-gradient-to-r from-blue-900 to-gray-900 text-white py-20">
                <div className="container mx-auto px-4">
                    <div className="max-w-3xl">
                        <h1 className="text-5xl font-bold mb-6">Our Services</h1>
                        <p className="text-xl text-blue-100">
                            Comprehensive engineering solutions across multiple sectors in Zambia
                        </p>
                    </div>
                </div>
            </section>

            <div className="container mx-auto px-4 py-8">
                <h2 className="text-3xl font-bold text-center mb-2">Our Service Categories</h2>
                <p className="text-gray-600 text-center mb-8">
                    Browse through our wide range of professional services
                </p>
                
                {/* Dynamic Category Filter */}
                <div className="flex flex-wrap justify-center gap-2 mb-8">
                    {categories.map(category => (
                        <button
                            key={category}
                            onClick={() => setActiveCategory(category)}
                            className={`px-4 py-2 rounded-full transition-all duration-200 ${
                                activeCategory === category 
                                    ? 'bg-blue-600 text-white shadow-lg' 
                                    : 'bg-white text-gray-700 border hover:bg-gray-50 hover:shadow-md'
                            }`}
                        >
                            {category === 'all' 
                                ? 'All Services' 
                                : category}
                        </button>
                    ))}
                </div>

                {/* Active Category Display */}
                {activeCategory !== 'all' && (
                    <div className="text-center mb-6">
                        <h3 className="text-2xl font-semibold text-blue-800">
                            {activeCategory} Services
                        </h3>
                        <p className="text-gray-500 mt-1">
                            Showing {filteredServices.length} {filteredServices.length === 1 ? 'service' : 'services'}
                        </p>
                    </div>
                )}

                {/* Services Grid */}
                {filteredServices.length > 0 ? (
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                        {filteredServices.map(service => (
                            <ServiceCard key={service.id} service={service} />
                        ))}
                    </div>
                ) : (
                    <div className="text-center py-12">
                        {activeCategory === 'all' ? (
                            <>
                                <p className="text-gray-500 text-lg mb-4">No services available at the moment.</p>
                                <p className="text-gray-400">Please check back later or contact us for more information.</p>
                            </>
                        ) : (
                            <>
                                <p className="text-gray-500 text-lg mb-4">No services found in the {activeCategory} category.</p>
                                <button
                                    onClick={() => setActiveCategory('all')}
                                    className="text-blue-600 hover:text-blue-800 font-medium underline"
                                >
                                    View all services
                                </button>
                            </>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default Services;